import React from 'react';
import './TezzPrivacyPage.scss'

const TezzPrivacyPage = () => {
    return (
        <div>
            <section className="privacy-policy">
                <div className="container">
                    <div className="text-center col-xs-12">
                            <h2> Privacy Policy </h2>
                            <hr style={{ border: "solid 1px #fbb000", marginTop: 0, marginBottom: 0, width: "15%" }} />
                        </div>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c8">This Privacy Policy (“</span>
                        <span className="c5">Policy</span>
                        <span className="c2">
                            ”) describes the policies and procedures on the collection, use, disclosure and protection of your information, when you use our website www.lynk.co.in
                            or the Tezz mobile application (collectively, “Platform”) made available by Scootsy Logistics Private Limited (“Company”, “we”, “us” and “our”), a
                            private company established under the laws of India having its registered office at No.55 Sy No.8-14, Ground Floor, I&amp;J Block, Embassy Tech Village,
                            Outer Ring Road, Devarbisanahalli, Bengaluru – 560103.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c2">The terms “you” and “your” refer to the user of the Platform.</span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c2">
                            Please read this Policy before using the Platform or submitting any personal information to us. This Policy is a part of and incorporated within, and is
                            to be read along with, the Terms of Use.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <h1 className="c1">
                        <span className="c5 c9">YOUR CONSENT</span>
                    </h1>
                    <p className="c11 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c8">
                            By using the Platform, you agree and consent to the collection, transfer, use, storage, disclosure and sharing of your information as described and
                            collected by us in accordance with this Policy. If you do not agree with the Policy, please do not use or access the Platform.
                        </span>
                    </p>
                    <h1 className="c1 c16">
                        <span className="c2" />
                    </h1>
                    <h1 className="c1">
                        <span className="c5">POLICY CHANGES</span>
                    </h1>
                    <p className="c1 c7">
                        <span className="c2" />
                    </p>
                    <p className="c1">
                        <span className="c2">
                            We may occasionally update this Policy and such changes will be posted on this page. If we make any significant changes to this Policy, we will
                            endeavour to provide you with reasonable notice of such changes, such as via prominent notice on the Platform or to your email address on record and
                            where required by applicable law, we will obtain your consent. To the extent permitted under the applicable law, your continued use of the Platform
                            after we publish or send a notice about our changes to this Policy shall constitute your consent to the updated Policy.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <h1 className="c1">
                        <span className="c5">LINKS TO OTHER WEBSITES</span>
                    </h1>
                    <p className="c1 c7">
                        <span className="c2" />
                    </p>
                    <p className="c1">
                        <span className="c2">
                            The Platform may contain links to other websites. Any personal information about you collected whilst visiting such websites is not governed by this
                            Policy. The Company shall not be responsible for and has no control over the practices and content of any website accessed using the links contained on
                            the Platform. This Policy shall not apply to any information you may disclose to any of our service providers/service personnel which we do not require
                            you to disclose to us or any of our service providers under this Policy.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <h1 className="c1">
                        <span className="c5">INFORMATION WE COLLECT FROM YOU</span>
                    </h1>
                    <p className="c1 c7">
                        <span className="c2" />
                    </p>
                    <p className="c1">
                        <span className="c2">
                            Your Device Information: In order to improve your app experience and lend stability to our Platform to you, we may collect information or employ third
                            party plugins that collect information about the devices you use to access our Platform, including the hardware models, operating systems and versions,
                            software, file names and versions, preferred languages, unique device identifiers, advertising identifiers, serial numbers, device motion information,
                            mobile network information, installed applications on device and phone state. The information collected thus will be disclosed to or collected directly
                            by these plugins and may be used to improve the content and/or functionality of the services offered to you. Analytics companies may use mobile device
                            IDs to track your usage of the Platform.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            Your account information: Your full name, email address, address, postal code, password and other information you may provide with your account, such as
                            your gender, mobile phone number, profile picture etc. You may optionally provide us with this information through third-party sign-in services. In such
                            cases, we fetch and store whatever information is made available to us by you through these sign-in services.{' '}
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            Your preferences: Your preferences and settings such as time zone and language. The search terms you have looked up and results you selected. How long
                            you used our Platform and which features you used, the ads you clicked on.{' '}
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            Your content: Information you provide through our Platform, including your ratings and/or reviews of our products and other information you provide to
                            us.{' '}
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            Your communications: Communications between you and other users, service providers, PDP, through our Platform; your participation in a survey, poll,
                            campaign, contest or promotion scheme; your request for certain features (e.g., newsletters, updates or other products); your communication with us
                            about employment and/or occupational/professional opportunities.{' '}
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            Your transactional information: If you purchase through our Platform, we may collect and store information about you to process your requests and
                            automatically complete forms for future transactions, including (but not limited to) your phone number, address, email, billing information in a
                            tokenized manner.{' '}
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            Usage information: Details of your use of our Platform, including traffic data, location data, logs and other communication data and the resources that
                            you access and use on or through our Platform.{' '}
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            Stored information and files: Our applications also may access metadata and other information associated with other files stored on your mobile device
                            with your consent.{' '}
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">Location information: Our applications collect real-time information about the location of your device, as permitted by you. </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">Last URL visited: The URL of the last web page you visited before visiting our websites. </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            Applications: If you use the Platform, we may collect information about the presence and/or absence and/or details pertaining to other applications on
                            your mobile phone.{' '}
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c12">
                            We use the information you provide to us to enhance the functionality and improve the quality of our Platform, and to personalize your experience while
                            using our Platform. We also use this information to display relevant advertising, provide support to you, communicate with you, and comply with our
                            legal obligations.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c2" />
                    </p>
                    <h1 className="c1">
                        <span className="c5 c9">COOKIES</span>
                    </h1>
                    <p className="c7 c11">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            The Platform and third parties with whom we partner, may use cookies, pixel tags, web beacons, mobile device IDs, “flash cookies (wherever applicable)”
                            and similar files or technologies to collect and store information with respect to your use of the Platform and third-party websites. Cookies are small
                            files that are stored on your browser or device by websites, apps, online media and advertisements. We use cookies and similar technologies for purposes
                            such as:
                        </span>
                    </p>
                    <p className="c1">
                        <span className="c0">- Authenticating users;</span>
                    </p>
                    <p className="c1">
                        <span className="c0">- Remembering user preferences and settings;</span>
                    </p>
                    <p className="c1">
                        <span className="c0">- Determining the popularity of content;</span>
                    </p>
                    <p className="c1">
                        <span className="c0">- Delivering and measuring the effectiveness of advertising campaigns;</span>
                    </p>
                    <p className="c1">
                        <span className="c0">
                            - Analysing site traffic and trends, and generally understanding the online behaviours and interests of people who interact with our services.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            A pixel tag (also called a web beacon or clear GIF) is a tiny graphic with a unique identifier, embedded invisibly on a webpage (or an online ad or
                            email), and is used to count or track things like activity on a webpage or ad impressions or clicks, as well as to access cookies stored on users’
                            computers. We use pixel tags to measure the popularity of our various pages, features and services. We also may include web beacons in e-mail messages
                            or newsletters to determine whether the message has been opened and for other analytics.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            To modify your cookie settings, please visit your browser’s settings. By using our Platform with your browser settings to accept cookies, you are
                            explicitly consenting to our use of cookies in the manner described in this section.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            We may also allow third parties to provide audience measurement and analytics services for us, to serve advertisements on our behalf across the
                            Internet, and to track and report on the performance of those advertisements. These entities may use cookies, web beacons, SDKs and other technologies
                            to identify your device when you visit the Platform, as well as when you visit other online sites and services.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c12">Please see our </span>
                        <span className="c10">
                            <a
                                className="c3"
                                href="https://www.google.com/url?q=https://www.swiggy.com/cookie-policy&sa=D&source=editors&ust=1751898440261580&usg=AOvVaw1BnIwzkmZH2S_5LrjoaRpl"
                            >
                                Cookie Policy
                            </a>
                        </span>
                        <span className="c12">
                            &nbsp;for more information regarding the use of cookies and other technologies described in this section, including regarding your choices relating to
                            such technologies.
                        </span>
                    </p>
                    <p className="c11 c7">
                        <span className="c0" />
                    </p>
                    <h1 className="c1">
                        <span className="c5">USES OF YOUR INFORMATION</span>
                    </h1>
                    <p className="c1 c7">
                        <span className="c2" />
                    </p>
                    <p className="c1">
                        <span className="c2">We use the information we collect for following purposes, including:</span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <ol className="c13 lst-kix_list_3-0 start" start={1}>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c2">
                                To provide, personalise, maintain and improve our products and services, such as to enable deliveries and other services, enable features to
                                personalise your Platform account;
                            </span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c2">
                                To carry out our obligations arising from any contracts entered into between you and us and to provide you with the relevant information and
                                services;
                            </span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c2">
                                To administer and enhance the security of our Platform and for internal operations, including troubleshooting, data analysis, testing, research,
                                statistical and survey purposes;
                            </span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c2">
                                To provide you with information about services we consider similar to those that you are already using, or have enquired about, or may interest you.
                                If you are a registered user, we will contact you by electronic means (e-mail or SMS or telephone or other internet based instant messaging systems)
                                with information about these services;
                            </span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c2">
                                To understand our users (what they do on our Platform, what features they like, how they use them, etc.), improve the content and features of our
                                Platform (such as by personalizing content to your interests), process and complete your transactions, make special offers, provide customer
                                support, process and respond to your queries;
                            </span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c2">To generate and review reports and data about, and to conduct research on, our user base and Service usage patterns;</span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c2">To allow you to participate in interactive features of our Platform, if any; or</span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c2">
                                To measure or understand the effectiveness of advertising we serve to you others, and to deliver relevant advertising to you.
                            </span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c2">To carry out academic research with academic partners</span>
                            <span className="c0">&nbsp;in an aggregated and anonymized manner. </span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c0">Administer and facilitate contests, campaigns, giveaways and sweepstakes.</span>
                        </li>
                    </ol>
                    <p className="c1 c7">
                        <span className="c2" />
                    </p>
                    <p className="c1">
                        <span className="c8">
                            We may combine the information that we receive from third parties with the information you give to us and information we collect about you for the
                            purposes set out above. Further, we may anonymize and/or de-identify information collected from you through the Platform or via other means, including
                            via the use of third-party web analytic tools. As a result, our use and disclosure of aggregated and/or de-identified information is not restricted by
                            this Policy, and it may be used and disclosed to others without limitation.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c2" />
                    </p>
                    <p className="c1">
                        <span className="c2">
                            We analyse the log files of our Platform that may contain Internet Protocol (IP) addresses, browser type and language, Internet service provider (ISP),
                            referring, app crashes, page viewed and exit websites and applications, operating system, date/time stamp, and clickstream data. This helps us to
                            administer the website, to learn about user behavior on the site, to improve our product and services, and to gather demographic information about our
                            user base as a whole.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c2" />
                    </p>
                    <h1 className="c1">
                        <span className="c5">DISCLOSURE AND DISTRIBUTION OF YOUR INFORMATION</span>
                    </h1>
                    <p className="c1 c7">
                        <span className="c2" />
                    </p>
                    <p className="c1">
                        <span className="c2">We may share your information that we collect for following purposes:</span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c5">With Service Providers: </span>
                        <span className="c8">
                            We may share your information with our vendors, consultants, marketing partners, research firms and other service providers or business partners, such
                            as payment processing companies, to support our business. For example, your information may be shared with outside vendors to send you emails and
                            messages or push notifications to your devices in relation to our Platform, to help us analyze and improve the use of our Platform, to process and
                            collect payments. We also may use vendors for other projects, such as conducting surveys or organizing sweepstakes for us.
                        </span>
                    </p>
                    <p className="c1">
                        <span className="c5">With Academic Partners: </span>
                        <span className="c8">We may share your information with our academic partners for the purpose of carrying out academic research.</span>
                    </p>
                    <p className="c1">
                        <span className="c6">With Connected Platforms/Apps:</span>
                        <span className="c0">
                            &nbsp;By providing your personal information, including addresses, phone numbers, ordering history, and other details during your ordering process, you
                            acknowledge and agree that such data may be used to personalize your experience across our ecosystem of services. This may include sharing and utilizing
                            your information seamlessly across any connected platforms or apps within the Group (defined below), or any other apps or platforms developed by Group,
                            enhancing functionality and providing consistent service when you access them using the same credentials.{' '}
                        </span>
                    </p>
                    <p className="c1">
                        <span className="c5">For Crime Prevention or Investigation: </span>
                        <span className="c8">We may share this information with governmental agencies or other companies assisting us, when we are:</span>
                    </p>
                    <ul className="c13 lst-kix_list_4-0 start">
                        <li className="c1 c4 li-bullet-0">
                            <span className="c2">Obligated under the applicable laws or in good faith to respond to court orders and processes; or</span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c0">
                                Detecting and preventing against actual or potential occurrence of identity theft, fraud, abuse of Platform and other illegal acts;{' '}
                            </span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c0">
                                Responding to claims that an advertisement, posting or other content violates the intellectual property rights of a third party;{' '}
                            </span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c0">
                                Under a duty to disclose or share your personal data in order to enforce our Terms of Use and other agreements, policies or to protect the rights,
                                property, or safety of the Company, our customers, or others, or in the event of a claim or dispute relating to your use of our{' '}
                            </span>
                            <span className="c2">Platform</span>
                            <span className="c0">.</span>
                        </li>
                        <li className="c1 c4 li-bullet-0">
                            <span className="c0">
                                This includes exchanging information with other companies and organisations for the purposes of fraud detection and credit risk reduction.
                            </span>
                        </li>
                    </ul>
                    <p className="c1">
                        <span className="c6">For Internal Use:</span>
                        <span className="c0">
                            &nbsp;We may share your information with any present or future member of our Group (as defined below) including our affiliates for our internal business
                            purposes. The term “Group” means, with respect to any person, any entity that is controlled by such person, or any entity that controls such person, or
                            any entity that is under common control with such person, whether directly or indirectly, or, in the case of a natural person, any Relative (as such
                            term is defined in the Companies Act, 1956 and Companies Act, 2013 to the extent applicable) of such person.{' '}
                        </span>
                    </p>
                    <p className="c1">
                        <span className="c6">With Advertisers and advertising networks:</span>
                        <span className="c0">
                            &nbsp;We may work with third parties such as network advertisers to serve advertisements on the Platform and on third-party websites or other media
                            (e.g., social networking platforms). These third parties may use cookies, JavaScript, web beacons (including clear GIFs), Flash LSOs and other tracking
                            technologies to measure the effectiveness of their ads and to personalize advertising content to you.{' '}
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            You cannot opt out of advertising on the Platform, you may opt out of much interest-based advertising on third party sites and through third party ad
                            networks (including DoubleClick Ad Exchange, Facebook Audience Network and Google AdSense). For more information, visit www.aboutads.info/choices.
                            Opting out means that you will no longer receive personalized ads by third parties ad networks from which you have opted out, which is based on your
                            browsing information across multiple sites and online services. If you delete cookies or change devices, your opt out may no longer be effective to
                            fulfill the purpose for which you provide it.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">We may share your information other than as described in this Policy if we notify you and you consent to the sharing.</span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c6 c9">DATA SECURITY PRECAUTIONS</span>
                    </p>
                    <p className="c1 c7 c14">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">We have in place appropriate technical and security measures to secure the information collected by us.</span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            You are advised not to send your full credit/debit card details through unencrypted electronic platforms. Where we have given you (or where you have
                            chosen) a username and password which enables you to access certain parts of the Platform, you are responsible for keeping these details confidential.
                            We ask you not to share your password with anyone.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            Please be aware that the transmission of information via the internet is not completely secure. Although we will do our best to protect your personal
                            data, we cannot guarantee the security of your data transmitted through the Platform. Once we have received your information, we will use strict
                            physical, electronic, and procedural safeguards to try to prevent unauthorised access.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c6 c9">OPT-OUT</span>
                    </p>
                    <p className="c1 c7">
                        <span className="c6 c9" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            When you sign up for an account, you are opting in to receive emails from us. You can log in to manage your email preferences or you can follow the
                            “unsubscribe” instructions in commercial email messages, but note that you cannot opt out of receiving certain administrative notices, service notices,
                            or legal notices from us.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            If you wish to withdraw your consent for the use and disclosure of your personal information in the manner provided in this Policy or you want your data
                            to be deleted, please write to us at support@scootsy.com. Please note that we may take time to process such requests, and your request shall take effect
                            no later than 5 (Five) business days from the receipt of such request, after which we will not use your personal data for any processing unless required
                            by us to comply with our legal obligations. We may not be able offer you the Platform upon such withdrawal of your consent.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c6">GRIEVANCE OFFICER AND PLATFORM SECURITY</span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            If you have any queries relating to the processing or usage of information provided by you in connection with this Policy, please email us at
                            support@scootsy.com or write to our Grievance Officer at the following address:
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">Swiggy Grievance Officer</span>
                    </p>
                    <p className="c1">
                        <span className="c0">No.55 Sy No.8-14, Ground Floor, I&amp;J Block,</span>
                    </p>
                    <p className="c1">
                        <span className="c0">Embassy Tech Village, Outer Ring Road,</span>
                    </p>
                    <p className="c1">
                        <span className="c0">Devarbisanahalli, Bengaluru – 560103</span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c12">If you come across any abuse or violation of the Policy, please report to </span>
                        <span className="c10">
                            <a className="c3" href="mailto:grievances@swiggy.in">
                                grievances@swiggy.in
                            </a>
                        </span>
                        <span className="c0">.</span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                    <p className="c1">
                        <span className="c0">
                            Further, please note that the Platform stores your data with the cloud platform of Amazon Web Services provided by Amazon Web Services, Inc., which may
                            store this data on their servers located outside of India. Amazon Web Services has security measures in place to protect the loss, misuse and alteration
                            of the information, details of which are available at https://aws.amazon.com/. The privacy policy adopted by Amazon Web Services are detailed in
                            https://aws.amazon.com/privacy. In the event you have questions or concerns about the security measures adopted by Amazon Web Services, you can contact
                            their data protection / privacy team / legal team or designated the grievance officer at these organisations, whose contact details are available in its
                            privacy policy, or can also write to our Grievance Officer at the address provided above.
                        </span>
                    </p>
                    <p className="c1 c7">
                        <span className="c0" />
                    </p>
                </div>
            </section>
        </div>
    );
};

export default TezzPrivacyPage;
